import {signOut} from 'aws-amplify/auth';

import {config} from '../config/amplify/auth';

// FNP-1685: sign out through the auth broker's /logout to this stage's
// redirectSignOut (the portal). Naming the URL explicitly is what stops Amplify
// throwing InvalidOriginException for a cross-origin logout target.
//
// On success Amplify has already set window.location to /logout, so do NOT
// navigate again straight away: a second assignment would replace that redirect.
// A rejection (tokens are cleared first either way) falls back to '/' at once.
// signOut() also resolves WITHOUT navigating when there is no OAuth session
// (D14b), so a resolved call falls back to '/' after a delay. A slow broker
// /logout may not have unloaded the page by then, and assigning location would
// cancel it, so the timer only acts when beforeunload never fired, i.e. nothing
// is navigating (D14c).
export const signOutViaBroker = async () => {
    const redirectUrl = config?.Cognito.loginWith?.oauth?.redirectSignOut[0];
    let leaving = false;
    const onLeave = () => {
        leaving = true;
    };
    window.addEventListener('beforeunload', onLeave);
    try {
        // global: false is signOut()'s own default; the typed input requires it.
        await signOut({global: false, oauth: {redirectUrl}});
        setTimeout(() => {
            if (!leaving) {
                window.location.href = '/';
            }
        }, 3000);
    } catch (error) {
        console.error('Sign out did not complete cleanly', error);
        window.location.href = '/';
    }
};
